module.exports = __webpack_public_path__ + "arrow-down_ACACAC.svg?1eee5ce5080d3afbe3d1aba811e567bf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/arrow-down_ACACAC.svg
// module id = 615
// module chunks = 0